<script setup lang="ts">
import { useAdvisor } from '#advisor-portal/state/useAdvisor'
import { ProjectAvatar } from '@forgd/ui-kit/blocks/avatars'
import { Button } from '@forgd/ui-kit/button'
import { Popover, PopoverContent, PopoverTrigger } from '@forgd/ui-kit/popover'
import { ChevronDownIcon } from '@heroicons/vue/24/outline'

const auth = useAuth()
const advisor = useAdvisor()

const { project } = storeToRefs(auth)
const { isCreateEngagementOpen } = storeToRefs(advisor)

const isPopoverOpen = ref(false)
</script>

<template>
  <Popover v-model:open="isPopoverOpen">
    <PopoverTrigger as-child>
      <Button data-testid="current-project" aria-label="Account and project menu" variant="outline" size="sm" class="py-2">
        <template v-if="auth.isAdvisor && advisor.isInPortal">
          <ProjectAvatar v-if="advisor.organization?.image" :src="advisor.organization.image" size="2xs" />
          <div class="max-w-37.5 truncate font-semibold uppercase">
            {{ advisor.organization?.name }}
          </div>
        </template>
        <template v-else-if="project">
          <ProjectAvatar :src="project.image" size="xs" />
          <div class="max-w-37.5 truncate font-semibold uppercase">
            {{ project.ticker || project.name }}
          </div>
        </template>
        <ChevronDownIcon class="text-primal transition" :class="isPopoverOpen ? 'rotate-180' : ''" aria-hidden="true" />
      </Button>
    </PopoverTrigger>
    <PopoverContent
      side="top"
      align="end"
      class="w-85 overflow-visible p-0"
    >
      <CoreHeaderProfileContent @close="isPopoverOpen = false" />
    </PopoverContent>
  </Popover>
  <CreateEngagementFormSlideover
    v-if="auth.isAdvisor"
    v-model:is-open="isCreateEngagementOpen"
    :advisor-organization-id="advisor.organization.id"
    @success="advisor.refreshData"
  />
</template>
